import { HostBinding, Component } from '@angular/core';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { environment } from '../../../environments/environment';
import { DocumentosService } from 'app/shared/documentos/documentos.service';
import { AgrupadorDocumentos, Documento } from 'models/documento';

@Component({
  selector: 'app-fies-prouni',
  templateUrl: './fies-prouni.component.html',
  styleUrls: ['./fies-prouni.component.scss'],
  animations: [routerTransition],
})
export class fiesProuniComponent {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';
  documentos: Documento[] = [];
  docsLoading = true;

  environment = environment;
  constructor(
    private documentosService: DocumentosService,
  ){
    if(this.environment.loginContexto !== "CEUMA") {
      window.location.href='/';
    }
  }


  ngOnInit() {
    this.documentosService.queryFiesProuni().
    then((groups: AgrupadorDocumentos[]) => {
      if (groups && groups.length > 0) {
        this.documentos = groups[0].documentos;
      }
      this.docsLoading = false;

      console.log(this.documentos)
    });
  }
}
